import React, { useState, useEffect } from 'react';

import { listPurchase, PurchaseModel, MagicLinkModel,  getMagicLink } from '../../utils/api/purchase';


import Navbar from '../../Components/Navbar';
import AutoMargin from 'Components/AutoMargin';
import { i18n } from 'utils/i18n/index';

interface PurchaseProps {}
const Purchases: React.FC<PurchaseProps> = () => {
  const [purchases, setPurchases] = useState<PurchaseModel[] | undefined>();
  const [magicLinks, setMagicLinks] = useState({});

  useEffect(() => {
    (async () => {
      const purchases = await listPurchase();
      setPurchases(purchases);
    })();
  }, []);

  const fetchMagicLink = async (id: string) => {
    try {
      const data = await getMagicLink(id);
      const purchase =  data.value.item as MagicLinkModel;
      console.log(purchase);
      setMagicLinks(prev => ({ ...prev, [id]: purchase }));
    } catch (error) {
      console.error('Error fetching magic link:', error);
    }
  };

  const translateStatus = (status: string) => {
    if (status=="completed") return i18n.t("accepted")
    return i18n.t(status);
  };

  return (
    <div>
      <Navbar />
      <AutoMargin className="w-full mt-4 p-2 lg:mt-7 max-w-7xl">
        <p className="text-xs">
          DASHBOARD / {i18n.t('storeMenu')} /{' '}
          <span className="text-primary">{i18n.t('myExchangesTitle')}</span>
        </p>
        <p className="text-xl lg:text-3xl mt-4 text-black">
          {i18n.t('myExchanges')}
        </p>
        <div className="mt-8 lg:mt-16 shadow rounded p-4 lg:p-7 mb-5">
          {!purchases ? (
            <p>{i18n.t('loading')}</p>
          ) : !purchases.length ? (
            <p className="ml-2">{i18n.t('noExchangeScore')}</p>
          ) : (
            <div className="mt-3">
              {purchases.map((product) => (
                <div key={product.id} className="mt-3">
                  <p className="text-lg font-medium text-black">{`${product.product.name}`}</p>
                  <p>{`${i18n.t('quantity')}: ${product.quantity}`}</p>
                  <p>{`${i18n.t('meritusSpent')}: ${product.meritus}`}</p>
                  <p>
                    {product?.additionalInformation?.observation
                      ? `${i18n.t('observation')} ${
                          product.additionalInformation.observation
                        }`
                      : ''}
                  </p>
                  <p>{`${i18n.t('date')} ${new Date(
                    product.createdAt
                  ).toLocaleString(i18n.t('dateLocaleString'), {
                    dateStyle: 'medium',
                    hour12: false,
                    timeStyle: 'short',
                  })}`}</p>
                  {/* <p>
                    {product?.additionalInformation?.observation
                      ? `${i18n.t("observation")} ${product.additionalInformation.observation}`
                      : ''}
                    </p>*/}
                  <p>{`${i18n.t('status')} ${translateStatus(
                    product.status
                  )}`}</p>
                  {product.product.supplier === "62faa030847a96f853687760" && (
                    <>
                      <button
                                className="text-base bg-primary-darker text-white font-bold border rounded-full px-1.5 text-center justify-center"
                                type="button"
                      onClick={() => fetchMagicLink(product?.extraFields?.todoVoucher?.value)}>
                        {i18n.t('get_magic_link')}
                      </button>
                      {magicLinks[product?.extraFields?.todoVoucher?.value] && (
                        <div>
                          <br/>
                          <strong>{i18n.t('click_here')}</strong>:
                          <a href={magicLinks[product?.extraFields?.todoVoucher?.value].magic_link} target="_blank" rel="noopener noreferrer" className="ml-2 text-blue-600 underline">
                            {magicLinks[product?.extraFields?.todoVoucher?.value].magic_link}
                          </a>
                        </div>
                      )}
                    </>
                  )}
                  <hr className="mt-3 border-lighter-70" />
                </div>
              ))}
            </div>
          )}
        </div>
      </AutoMargin>
    </div>
  );
};
export default Purchases;
